export default {
  namespaced: true,
  state: {
    unreadCount: 0,
    latestMessage: null,
  },
  mutations: {
    incrementUnread(state) {
      state.unreadCount++;
    },
    resetUnread(state) {
      state.unreadCount = 0;
    },
    setLatestMessage(state, msg) {
      state.latestMessage = msg;
    },
  },
  actions: {
    addIncomingMessage({ commit }, msg) {
      commit("incrementUnread");
      commit("setLatestMessage", msg);
    },
    clearUnread({ commit }) {
      commit("resetUnread");
    },
  },
  getters: {
    getUnreadCount: (state) => state.unreadCount,
    getLatestMessage: (state) => state.latestMessage,
  },
};